import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams, useNavigate } from 'react-router-dom'

import Container from '@mui/material/Container'
import { PAGES } from '../navigation/routes'
import Loading from '../loading/Loading'

import { setErrorNotification } from '../../reducers/notificationReducer'
import { confirmEmailChange } from '../../reducers/userReducer'
import { ActivateStyle } from '../styles'

// Landing page for the link mailed to a new address after an email change is
// requested. Mirrors Activate: hand the id and token to the backend, then go home.
const ConfirmEmail = () => {
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (searchParams.get('token') && searchParams.get('id')) {
            dispatch(confirmEmailChange(searchParams.get('id'), searchParams.get('token')))
            navigate(PAGES.home.path)
        } else {
            dispatch(setErrorNotification('Invalid confirmation link!'))
            navigate(PAGES.home.path)
        }
    }, [dispatch, navigate, searchParams])

    return (
        <Container {...ActivateStyle.container.props} sx={ActivateStyle.container.style} >
            <Loading />
        </Container>
    )
}

export default ConfirmEmail
